import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouteService } from '../../../../../../services/route.service';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import {
    SectionTeacherInformationComponent
} from './sections/section-teacher-information/section-teacher-information.component';
import {
    SectionStudentInformationComponent
} from './sections/section-student-information/section-student-information.component';
import { SectionToolsComponent } from './sections/section-tools/section-tools.component';
import { SectionExternalToolsComponent } from './sections/section-external-tools/section-external-tools.component';
import { SectionInteractivityComponent } from './sections/section-interactivity/section-interactivity.component';

@Component({
    selector: 'app-feature-information',
    templateUrl: './feature-information.component.html',
    styleUrls: ['./feature-information.component.scss'],
    imports: [
        SectionTeacherInformationComponent,
        SectionStudentInformationComponent,
        SectionToolsComponent,
        SectionExternalToolsComponent,
        SectionInteractivityComponent
    ],
    standalone: true
})
export class FeatureInformationComponent {
    @Input() modalId: string;
    @Input() showContent: boolean;
    @Output() readonly change = new EventEmitter();

    routeService = inject(RouteService);
    applicationStateService = inject(ApplicationStateService);

    slideConfig = {
        autoplay: false,
        variableWidth: true,
        dots: false,
        arrows: false,
        swipe: true,
        draggable: true,
        infinite: true,
        centerMode: true,
        swipeToSlide: true,
        speed: 300
    };
}